import ApiClient from './ApiClient';

class AiBotSettingsAPI extends ApiClient {
  constructor() {
    super('ai_bot_settings', { accountScoped: true });
  }

  getSettings() {
    return this.get();
  }

  getUsageSummary() {
    return axios.get(`${this.url}/usage_summary`);
  }

  createEvolutionInstance(instanceName) {
    return axios.post(`${this.url}/evolution_create`, {
      instance_name: instanceName,
    });
  }

  getCompanies() {
    return axios.get(`${this.url}/companies`);
  }

  refreshOperationalStates() {
    return axios.post(
      `${this.url}/refresh_operational_states`
    );
  }

  getCompany(companyId) {
    return axios.get(`${this.url}/companies/${companyId}`);
  }

  updateCompany(companyId, data) {
    return axios.put(`${this.url}/companies/${companyId}`, data);
  }

  createCompany(data) {
    return axios.post(`${this.url}/companies`, data);
  }

  toggleCompany(companyId) {
    return axios.post(`${this.url}/companies/${companyId}/toggle`);
  }

  deleteCompany(companyId, confirmation) {
    return axios.delete(`${this.url}/companies/${companyId}`, {
      data: { confirmation },
    });
  }

  getOfficialWhatsappInboxes() {
    return axios.get(`${this.url}/official_whatsapp_inboxes`);
  }

  getEvolutionStatus() {
    return axios.get(`${this.url}/evolution_status`);
  }

  getEvolutionQr() {
    return axios.get(`${this.url}/evolution_qr`);
  }

  getEvolutionStatusForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings/evolution_status`
    );
  }

  getEvolutionQrForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings/evolution_qr`
    );
  }

  updateSettings(data) {
    return axios.patch(this.url, {
      ai_bot_setting: data,
    });
  }

  getUsageSummaryForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings/usage_summary`
    );
  }


  getLocalUsageSummaryForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings/local_usage_summary`
    );
  }
  getSettingsForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings`
    );
  }

  updateSettingsForAccount(accountId, data) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/ai_bot_settings`,
      {
        ai_bot_setting: data,
      }
    );
  }

  getCompaniesDashboardSummary() {
    return axios.get(
      `${this.url}/companies_dashboard_summary`
    );
  }


  getInboxesForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/inboxes`
    );
  }

  getTeamsForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/teams`
    );
  }
  getOperationalHistoryForAccount(
    accountId,
    limit = 50
  ) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings/operational_history`,
      {
        params: { limit },
      }
    );
  }

  getOperationalHistory(limit = 50) {
    return axios.get(
      `${this.url}/operational_history`,
      {
        params: { limit },
      }
    );
  }

  createOperationalEventForAccount(
    accountId,
    payload
  ) {
    return axios.post(
      `/api/v1/accounts/${accountId}/ai_bot_settings/create_operational_event`,
      payload
    );
  }

  createOperationalEvent(payload) {
    return axios.post(
      `${this.url}/create_operational_event`,
      payload
    );
  }


  getCommercialUsageSummaryForAccount(accountId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/ai_bot_settings/commercial_usage_summary`
    );
  }

}

export default new AiBotSettingsAPI();
